export default __webpack_public_path__ + "static/bunker-footer-4dd783313c69cab99f78168237bb7e1e.jpg";